import React from 'react';
import './EsimBackButton.scss';

const EsimBackButton = ({ onClick }) => {
    return (
        <div className='esim-back-button'>
            <button type='button' className='esim-back-button__btn' onClick={onClick} aria-label='חזרה'>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <path
                        d='M5.26007 3.54401C4.88856 3.16679 4.91868 2.58299 5.32733 2.24006C5.70456 1.92351 6.27246 1.92285 6.6498 2.22132L6.73994 2.30215L11.7399 7.37907C12.0578 7.70181 12.0843 8.18052 11.8194 8.52926L11.7399 8.62093L6.73995 13.6978C6.36844 14.0751 5.73599 14.1029 5.32733 13.7599C4.95011 13.4434 4.89543 12.9216 5.18145 12.5465L5.26007 12.456L9.649 8.00092L5.26007 3.54401Z'
                        fill='currentColor'
                    />
                </svg>
            </button>
        </div>
    );
};

export default EsimBackButton;
